module.exports = __webpack_public_path__ + "static/media/isdin.a681c798.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/isdin.png
// module id = 129
// module chunks = 0